export default __webpack_public_path__ + "static/media/covidIndex.d4370b28.png";